import { Injectable, inject, signal, computed } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { PortalThemeConfig } from '../models/portal-theme.model';
import { PORTAL_THEMES, DONOR_THEME } from '../config/portal-themes';

@Injectable({ providedIn: 'root' })
export class PortalThemeService {
  private readonly document = inject(DOCUMENT);

  private readonly _portalId = signal<string>(DONOR_THEME.id);
  readonly portalId = this._portalId.asReadonly();

  readonly activeTheme = computed<PortalThemeConfig>(() => PORTAL_THEMES[this._portalId()] ?? DONOR_THEME);

  readonly logoPath = computed(() => this.activeTheme().logoPath);
  readonly portalLabel = computed(() => this.activeTheme().label);

  setPortal(portalId: string): void {
    if (this._portalId() === portalId) return;
    this._portalId.set(portalId);
    this.applyTheme(this.activeTheme());
  }

  applyCurrentTheme(): void {
    this.applyTheme(this.activeTheme());
  }

  private applyTheme(config: PortalThemeConfig): void {
    const root = this.document.documentElement;
    for (const [prop, value] of Object.entries(config.tokens)) {
      root.style.setProperty(prop, value);
    }
  }
}
